import { useState } from "react"
import { getReference } from "lib/@hooks/use-reference"
import { ReferenceValueUpdated } from "event-definitions"

export function useAmendCollapse(draftId, keyLabel = "authorNotes") {
    const key = `${keyLabel}-expanded-${draftId}`
    const bulkExpanded = getReference()[key] ?? false
    const [isCollapsed, setIsCollapsed] = useState(!bulkExpanded)

    ReferenceValueUpdated(key).useEvent(syncFromBulk)

    return { isCollapsed, onToggleCollapsed }

    function syncFromBulk() {
        setIsCollapsed(!getReference()[key])
    }

    function onToggleCollapsed() {
        setIsCollapsed((v) => !v)
    }
}
